
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/privacy",
      function () {
        return require("private-next-pages/article/privacy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/privacy"])
      });
    }
  